import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getAll(params) {
    return backofficeService.Api().get('business', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        // console.log('error on business', error)
        throw error
      })
  },

  /**
   * Get category by id
   * @param {*} params Query Options
   */
  getById(id, params) {
    return backofficeService.Api().get(`business/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    // console.log('here in create', data)
    return backofficeService.Api().post('business', data)
      .then(response => response)
      .catch((error) => {
        // console.log('here in error', error)
        throw error
      })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`business/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete category
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`business/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Get All businessRights
   * @param {*} params
   
   */

  getAllbusinessRights() {
    return backofficeService.Api().get('businessRightCatalog')
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
  * Get All AccountType
  * @param {*} params
  
  */

  getAllAccountType() {
    return backofficeService.Api().get('api/business/accountType')
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getRepairNestMarketplace() {
    return backofficeService.Api().get('business/repairnest-marketplace')
      .then(response => {
        const data = response.data && response.data.data
        if (!data || typeof data.enabled !== 'boolean') {
          throw new Error('Invalid RepairNest Marketplace response')
        }
        return data
      })
      .catch((error) => {
        throw error
      })
  },

  updateRepairNestMarketplace(enabled) {
    return backofficeService.Api().put('business/repairnest-marketplace', {
        enabled
      })
      .then(response => {
        const data = response.data && response.data.data
        if (!data || typeof data.enabled !== 'boolean') {
          throw new Error('Invalid RepairNest Marketplace response')
        }
        return data
      })
      .catch((error) => {
        throw error
      })
  },
}
